// Venue control API

import { apiClient } from './client';
import type { VenueStatusResponse, SetVenueResponse } from '../types/venues';

/**
 * Venue control API endpoints
 */
export const venuesApi = {
  /**
   * Get current venue status
   * Requires Management permission
   */
  getStatus: (): Promise<VenueStatusResponse> =>
    apiClient.get<VenueStatusResponse>('/api/venues/status'),

  /**
   * Set the active venue for new orders
   * Requires Management permission
   */
  setActive: (venue: string): Promise<SetVenueResponse> =>
    apiClient.request<SetVenueResponse>('/api/venues/active', {
      method: 'PUT',
      body: JSON.stringify({ venue }),
    }),
};
